// Generated file : do not modify
export enum PaysRegions
{
  NONE = 0,
  FRANCAIS,
  UNION_EUROPEENNE,
  ESPACE_ECONOMIQUE_EUROPEEN
};

import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Pays
export default class Pays  {
  // Identifiant unique
  public id: number;
  // Libellé
  public nom: string;
  // Libellé DSN
  public dsnPaysLabel: string;
  // Nationalite
  public nationalite: string;
  // Code INSEE
  public code: string;
  // Code Numérique
  public codeNum: number;
  // Code 2 digits
  public codeDigit2: string;
  // Code
  public codeDigit3: string;
  // Région
  public region: PaysRegions;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.nom = '';
    this.dsnPaysLabel = '';
    this.nationalite = '';
    this.code = '';
    this.codeNum = 0;
    this.codeDigit2 = '';
    this.codeDigit3 = '';
    this.region = PaysRegions.NONE;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: Pays): Pays {
    const newPays: Pays = new Pays();
    newPays.id = obj.id;
    newPays.nom = obj.nom;
    newPays.dsnPaysLabel = obj.dsnPaysLabel;
    newPays.nationalite = obj.nationalite;
    newPays.code = obj.code;
    newPays.codeNum = obj.codeNum;
    newPays.codeDigit2 = obj.codeDigit2;
    newPays.codeDigit3 = obj.codeDigit3;
    newPays.region = obj.region;
    newPays.canUpdate = obj.canUpdate;
    newPays.canDelete = obj.canDelete;
    newPays.display = obj.display;
    newPays.notifDefType = obj.notifDefType;
    return newPays;
  }

  public toJsonPays (): string {
    const json = {
      nom: this.nom,
      dsnPaysLabel: this.dsnPaysLabel,
      nationalite: this.nationalite,
      code: this.code,
      codeNum: this.codeNum,
      codeDigit2: this.codeDigit2,
      codeDigit3: this.codeDigit3,
      region: this.region,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromPays (obj: Pays): void {
    this.id = obj.id;
    this.nom = obj.nom;
    this.dsnPaysLabel = obj.dsnPaysLabel;
    this.nationalite = obj.nationalite;
    this.code = obj.code;
    this.codeNum = obj.codeNum;
    this.codeDigit2 = obj.codeDigit2;
    this.codeDigit3 = obj.codeDigit3;
    this.region = obj.region;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
  }

  public comparePays (value: Pays): boolean {
    return (this.toJsonPays() == value.toJsonPays());
  }

  public clonePays (): Pays {
    return Pays.fromJson(this);
  }

  public create (): Promise<Pays> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/pays/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromPays(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public update (): Promise<Pays> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/pays/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromPays(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public delete (): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.delete('api/pays/' + this.id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/pays/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getByCode (code: string): Promise<Pays> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/pays/getByCode/' + code, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(Pays.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(payss: Pays[]) {
  }
}
